export const getLastPath = (path) => {
  return path.substring(path.lastIndexOf('/') + 1)
}
